import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const detectCSVFormatFn = httpsCallable(functions, 'detectCSVFormat', { timeout: 30000 });

export async function detectCSVFormatAI(csvText, fileTypeHint) {
  const sampleSize = fileTypeHint === 'brokerage' ? 25 : 15;
  const sample = csvText.split(/\r?\n/).filter(l => l.trim()).slice(0, sampleSize).join('\n');
  const result = await detectCSVFormatFn({ csvSample: sample, fileTypeHint });
  return result.data;
}
